import ActionType from '../../../actions/ActionType'
import Fuse from 'fuse.js'
import { uniq } from 'lodash'
import taskTypeIDToNameMap from 'utils/taskTypeIDToNameMap'

export default (state = { value: [], initialValue: [] }, action) => {
  switch (action.type) {
    case ActionType.Tasks.HANDLE_FIELD_CHANGE:
      if (action.payload.name === 'selectedActionPrediction') {
        return { ...state, value: [] }
      }
      return state
    case ActionType.Tasks.VALIDATION_FAILURE:
      const dup = state
      action.errors.forEach((error) => {
        if (
          error.dataPath === '.send_email.trigger_data.to' ||
          error.dataPath === 'send_sms.trigger_data.to'
        ) {
          dup.error = error.message
        }
      })
      return dup
    case ActionType.Tasks.HANDLE_MULTI_CHANGE:
      return { ...state, value: action.payload }
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload) {
        const taskType =
          taskTypeIDToNameMap?.[action.payload?.task_type_id]?.payload_name
        console.log(taskType)
        console.log(action.payload[taskType])

        const contacts = action.payload?.[taskType]?.trigger_data?.to
          ?.contact_ids
          ? action.payload[taskType].trigger_data.to.contact_ids.map(
              contactID => action.contactsByID2[contactID],
            )
          : []
        console.log(contacts)

        const groups = action.payload?.[taskType]?.trigger_data?.to
          ?.contact_group_ids
          ? action.payload[taskType].trigger_data.to.contact_group_ids.map(
              groupID => action.groupsByID2[groupID],
            )
          : []
        console.log(groups)

        const value = [...contacts, ...groups]
        return {
          value,
          initialValue: value,
        }
      }
      return { value: [], initialValue: [] }
    case ActionType.Contacts.CREATE_TASK_WITH_CONTACT:
      return {
        ...state,
        value: [action.payload.contact],
      }
    case ActionType.LUIS.GET_SUCCESS:
      const intent = action.payload.body.topScoringIntent.intent
      const entities = action.payload.body.entities
      if (
        (intent === 'Send SMS' || intent === 'Send Email' || 'Create A Task') &&
        entities.length &&
        action.contacts2 &&
        action.groupsByID2
      ) {
        const oldState = state.value
        const newValues = []

        entities.forEach((entity) => {
          if (entity.type === 'builtin.personName' || entity.type === 'GROUP') {
            const arr =
              entity.type === 'builtin.personName'
                ? action.contacts2
                : Object.values(action.groupsByID2)
            const fuse = new Fuse(arr, {
              shouldSort: true,
              threshold: 0.6,
              location: 0,
              distance: 100,
              maxPatternLength: 32,
              minMatchCharLength: 1,
              keys: ['label'],
            })
            let results = fuse.search(entity.entity)

            if (results[0]) {
              newValues.push(results[0])
            }
          }
        })
        return { ...state, value: uniq(oldState.concat(newValues)) }
      }
      return state
    default:
      return state
  }
}
